export const messagingMetricsTableColumns = (translate) => [
  {
    prop: 'fullname',
    title: translate('common.fields.name'),
    width: '35%',
    sortingEnabled: true,
  },
  {
    prop: 'avg_resp_30',
    title: translate('dashboard.days_count', { count: 30 }),
    width: '21.66%',
    sortingEnabled: true,
  },
];

export const permitStatusMetricsTableColumns = (translate) => [
  {
    prop: 'fullname',
    title: translate('common.fields.name'),
    width: '25%',
    sortingEnabled: true,
  },
  {
    prop: 'filled_30',
    title: translate('dashboard.permit_metrics.filled'),
    width: '25%',
    sortingEnabled: true,
  },
  {
    prop: 'skipped_30',
    title: translate('dashboard.permit_metrics.skipped'),
    width: '25%',
    sortingEnabled: true,
  },
  {
    prop: 'completion_rate_30',
    title: translate('dashboard.permit_metrics.completion_rate'),
    width: '25%',
    sortingEnabled: true,
  },
];

export const permitActionDatesMetricsTableColumns = (translate) => [
  {
    prop: 'fullname',
    title: translate('common.fields.name'),
    width: '18.5%',
    sortingEnabled: true,
  },
  {
    prop: 'total_30',
    title: translate('dashboard.permit_metrics.total'),
    width: '13.5%',
    sortingEnabled: true,
  },
  {
    prop: 'filled_30',
    title: translate('dashboard.permit_metrics.filled'),
    width: '15%',
    sortingEnabled: true,
  },
  {
    prop: 'skipped_30',
    title: translate('dashboard.permit_metrics.skipped'),
    width: '15%',
    sortingEnabled: true,
  },
  {
    prop: 'filled_shared_30',
    title: translate('dashboard.permit_action_date_metrics.filled_shared'),
    width: '17.5%',
    sortingEnabled: true,
  },
  {
    prop: 'completion_rate_30',
    title: translate('dashboard.permit_metrics.completion_rate'),
    width: '15%',
    sortingEnabled: true,
  },
];
